import {setPointerPosition} from '../section.cds2-slider-with-tooltips/initTabs/setPointerPosition';

export const initMortgageTabs = () => {
	const subsidizedMortgageSection = document.querySelector( 'section.cds2-mortgage-calculator.subsidized' );
	const mortgageTabs = document.querySelector( 'section.cds2-mortgage-calculator.subsidized div.tabs' );

	if ( !subsidizedMortgageSection || !mortgageTabs )
	{
		return;
	}

	subsidizedMortgageSection.querySelector( 'input[name*="mortgage-calculator-bank"]' ).checked = true;
	
	const pointer = mortgageTabs.querySelector( 'li.pointer' );
	const currentOption = subsidizedMortgageSection.querySelector( 'input[name*="mortgage-calculator-bank"]:checked' ).id;
	let currentLabel = mortgageTabs.querySelector( `label[for="${currentOption}"]` );

	const setNewCurrent = ( value ) => {
		setPointerPosition( currentLabel, pointer );
		currentLabel.parentNode.classList.add( 'current' );

		subsidizedMortgageSection.querySelector( 'ul.programs-cards.current' ).classList.remove( 'current' );
		subsidizedMortgageSection.querySelector( `ul.programs-cards[data-bank="${value}"]` ).classList.add( 'current' );
		subsidizedMortgageSection.querySelector( 'form' ).dataset.coefficient = subsidizedMortgageSection.querySelector( 'ul.programs-cards.current' ).dataset.coefficient;
	};

	setTimeout( () => {
		const currentValue = subsidizedMortgageSection.querySelector( 'input:first-child' ).value;
		
		setNewCurrent( currentValue );
	}, 1000 );

	subsidizedMortgageSection.addEventListener( 'change', ( evt ) => {
		if ( !/mortgage-calculator-bank/u.test( evt.target.name ) )
		{
			return;
		}
		
		currentLabel.parentNode.classList.remove( 'current' );
		currentLabel = mortgageTabs.querySelector( `label[for="${evt.target.id}"]` );
		setNewCurrent( evt.target.value );
	} );

	const handleResize = () => {
		const heading = subsidizedMortgageSection.querySelector( 'h2' );

		mortgageTabs.style.width = window.innerWidth < 1024 ? '' : `calc( 100% - ${heading.offsetWidth + 40}px )`;
	};

	handleResize();
	window.addEventListener( 'resize', handleResize );
};
